import React from 'react';
import './project.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/fontawesome-free-brands';


const Project = (props) => {
  let imageClass;
  if (props.image === null) {
    imageClass = "hidden";
  }
  return (
    <React.Fragment>
      <div className={`project-image ${imageClass}`}>
        <img src={props.image}/>
      </div>
      <div className="project-desc">
        {props.desc}
      </div>
      <div className="project-links">
        <span><a href={props.git} target="_blank"><FontAwesomeIcon className="github-icon" icon={faGithub} /></a></span>
        <span><a href={props.live} target="_blank">Live</a></span>
      </div>
    </React.Fragment>
  );
};

export default Project;



// WEBPACK FOOTER //
// ./src/pages/project.jsx